import { api } from '../core/net';

/**
 * Fetches the merged configuration jsonValue for a given configuration.
 * @param configurationId - The configuration ID.
 * @param tenantId - The tenant ID.
 * @param serviceLine - The service line.
 * @returns The merged configuration's jsonValue object, or {} if not found.
 */
export async function fetchMergedConfigurationJsonValue(
  configurationId: string,
  tenantId: string,
  serviceLine: string
): Promise<Record<string, any>> {
  let effectiveServiceLine = serviceLine;
  if (serviceLine === 'Bedside Pro') {
    effectiveServiceLine = 'Inpatient Professional Coding';
  }

  const response: any = await api({
    endpoint: `/configuration/detail/${configurationId}/${tenantId}/v2?merge=true&serviceLine=${effectiveServiceLine}`,
    init: {
      method: 'GET'
    }
  });

  if (!Array.isArray(response) || response.length === 0) {
    console.warn(
      `[fetchMergedConfigurationJsonValue] No configuration found for configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${effectiveServiceLine}`
    );
    return {};
  }

  const configObj = response[0];
  if (!configObj || !Array.isArray(configObj.values)) {
    console.warn(
      `[fetchMergedConfigurationJsonValue] Config object missing or values not array for configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${effectiveServiceLine}`
    );
    return {};
  }

  const mergedValueObj = configObj.values.find(
    (v: any) => v.value === 'MERGED'
  );

  if (!mergedValueObj || !mergedValueObj.jsonValue) {
    console.warn(
      `[fetchMergedConfigurationJsonValue] No merged value found for configurationId=${configurationId}, tenantId=${tenantId}, serviceLine=${effectiveServiceLine}`
    );
    return {};
  }

  return mergedValueObj.jsonValue;
}
